import { combineReducers } from 'redux';
import {
  authenticationReducer,
  breadcrumbsReducer,
  popupAlertsReducer,
} from './index';

export const rootReducer = combineReducers({
  popupAlertsReducer,
  authenticationReducer,
  breadcrumbsReducer,
});
